import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import Navbar from '../Navbar';
import Footer from '../Footer';

const ReferencesPage = () => {
  const { language } = useLanguage();

  const brands = [
    { name: 'Decathlon', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/inhr8w4t_DECATHLON.png' },
    { name: 'Ellesse', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/42vfu7oc_ellesse.png' },
    { name: 'FC Bayern München', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/ifoy288s_fc%20bayern.png' },
    { name: 'Finisterre', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/as9tbkty_finisterre.png' },
    { name: 'GAP', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/4urvo12v_GAP.png' },
    { name: 'Happy Socks', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/wxo5paje_happy%20socks.png' },
    { name: 'Hummel', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/qs02t54n_hummel.png' },
    { name: 'IKEA', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/98j0qlg4_IKEA.png' },
    { name: 'KAFT', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/1o99uci2_KAFT.png' },
    { name: 'Lee Cooper', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/0kysdttr_Lee%20Cooper.png' },
    { name: 'MAAS', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/04ly8ppg_maas.png' },
    { name: 'Marks & Spencer', logo: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/2znei215_Marks%20Spencer.png' },
    { name: 'Mini Rodini', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/iml9xg4g_minirodini.png' },
    { name: 'Toad&Co', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/pb7zuqv8_toad%20co.png' },
    { name: 'Tommy Hilfiger', logo: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/iixd3evq_tommy.png' }
  ];

  const content = {
    en: {
      hero: {
        title: 'Trusted by Brands Across 30+ European Countries',
        subtitle: 'For over 40 years, we\'ve supplied woven labels, care labels, hangtags, heat transfers, patches, and packaging to fashion brands and manufacturers across Europe and beyond. Our work runs through more than 40 million pieces every month across four Istanbul facilities.'
      },
      stats: [
        { number: '40M+', label: 'pieces/month' },
        { number: '30+', label: 'European countries' },
        { number: '43+', label: 'years of experience' },
        { number: '100+', label: 'Global brands' }
      ],
      s01: {
        number: '01',
        title: 'Brands We Serve'
      },
      s02: {
        number: '02',
        title: 'Want to See Samples?',
        text: 'We can send a physical sample kit, including woven labels, care labels, hangtags, heat transfers, and packaging, within 5 working days to anywhere in Europe.',
        primaryBtn: 'Request a Sample Kit',
        secondaryBtn: 'Talk to Sales'
      }
    },
    tr: {
      hero: {
        title: '30+ Avrupa Ülkesindeki Markalar Tarafından Tercih Ediliyoruz',
        subtitle: '40 yılı aşkın süredir Avrupa ve ötesindeki moda markalarına ve üreticilere dokuma etiket, bakım etiketi, karton etiket, ısı transfer, yama ve ambalaj tedarik ediyoruz. Almanya\'daki premium triko evlerinden Fransa\'daki aktif giyim markalarına kadar, dört İstanbul tesisimizde her ay 40 milyondan fazla adet üretim gerçekleştiriyoruz.'
      },
      stats: [
        { number: '40M+', label: 'adet/ay' },
        { number: '30+', label: 'Avrupa ülkesi' },
        { number: '43+', label: 'yıllık deneyim' },
        { number: '100+', label: 'Global marka' }
      ],
      s01: {
        number: '01',
        title: 'Hizmet Verdiğimiz Markalar'
      },
      s02: {
        number: '02',
        title: 'Numune Görmek İster misiniz?',
        text: 'Dokuma etiketler, bakım etiketleri, karton etiketler, ısı transferler ve ambalaj dahil fiziksel numune setini Avrupa\'nın her yerine 5 iş günü içinde gönderebiliriz.',
        primaryBtn: 'Numune Seti Talep Edin',
        secondaryBtn: 'Satış Ekibiyle Konuşun'
      }
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-white" data-testid="references-page">
      <Navbar />
      
      {/* Hero */}
      <section className="relative min-h-[350px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/j2wu35i4_sadasf.png" alt="Custom woven labels made by Etiteks for international fashion brands" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/55" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 pb-12 pt-32">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight" data-testid="references-title">
            {t.hero.title}
          </h1>
          <p className="text-lg text-gray-200 max-w-3xl leading-relaxed">
            {t.hero.subtitle}
          </p>
        </div>
      </section>

      {/* Stat Strip */}
      <section className="py-12 border-b border-gray-200" data-testid="stat-strip">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {t.stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">{stat.number}</div>
                <div className="text-sm text-gray-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="py-16 border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-10 text-center">{t.s01.title}</h2>
            
            <div 
              className="grid grid-cols-3 md:grid-cols-5 gap-x-10 gap-y-10 items-center justify-items-center"
              data-testid="references-logo-grid"
            >
              {brands.map((brand, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center w-full group"
                  data-testid={`reference-logo-${index}`}
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    loading="lazy"
                    className="h-10 md:h-12 w-auto max-w-[120px] object-contain transition-all duration-500 group-hover:scale-110"
                    style={{ filter: 'grayscale(100%) opacity(0.55)' }}
                    onMouseEnter={(e) => { e.currentTarget.style.filter = 'grayscale(0%) opacity(1)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.filter = 'grayscale(100%) opacity(0.55)'; }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Samples CTA */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{t.s02.title}</h2>
            <p className="text-gray-500 mb-8 leading-relaxed">{t.s02.text}</p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/contact"
                className="inline-block px-8 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-medium rounded transition-colors"
                data-testid="request-sample-btn"
              >
                {t.s02.primaryBtn}
              </Link>
              <Link 
                to="/contact"
                className="inline-block px-8 py-3 border border-gray-300 hover:border-gray-400 text-gray-700 text-sm font-medium rounded transition-colors"
                data-testid="talk-to-sales-btn"
              >
                {t.s02.secondaryBtn}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReferencesPage;
